import * as Moment from 'moment';
import {extendMoment, MomentRange} from 'moment-range';

export const useMoment = (): typeof Moment & MomentRange => {
  const moment = extendMoment(Moment);
  moment.locale('de');
  return moment;
};
